import axios from "axios";

export default class JdApi {
  static getBaseURl() {
    return `${process.env.REACT_APP_PUBLIC_URL}`;
  }

  static async createfileId({ token, file }) {
    const url = `${this.getBaseURl()}/assessment/jd/upload-file`;

  
    try {
      const data = await axios.post(url, file, { 
        headers: {
          "Authorization": `Bearer ${token}`
        },
      });
  
      return { status: 200, data };
    } catch (error) {
      throw error;
    }
  }
  
  static async createJdId({ token, fileId, description, name }) {
    const url = `${this.getBaseURl()}/jd/upload`;
    console.log(fileId, description, name);
    
    const requestBody = {
      fileId: fileId,
      additionalText: description,
      name: name,
    };
  
    try {
      const { data } = await axios.post(url, requestBody, { // ✅ Pass requestBody here
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
  
      return { status: 200, data };
    } catch (error) {
      throw error;
    }
  }
  
 

}
